import { useEffect, useMemo, useState } from 'react';
import { ReactComponent as CrossIcon } from '../assets/images/plus-s.svg';

const Banner = () => {
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    const rawVal = localStorage.getItem('banner');
    let val = false;
    try {
      val = JSON.parse(rawVal);
    } catch {
      val = false;
    }
    setIsShow(val);
  }, []);

  const bannerText = useMemo(() => localStorage.getItem('banner_text'), []);

  const click = () => {
    setIsShow(false);
    localStorage.setItem('banner', false);
  };
  if (!isShow) {
    return <></>;
  }

  return (
    <div className="banner">
      <div className="banner-block">
        <div className="d-flex">{bannerText}</div>
        <button className="reset-btn ml-auto" type="button" onClick={click}>
          <CrossIcon height={24} width={24} />
        </button>
      </div>
    </div>
  );
};

export default Banner;
